import {JanglTextareaController as controller} from './controller.js';
import templateUrl from './template.html';

export const janglTextareaComponent = {
    templateUrl: templateUrl,
    controller: controller,
    bindings: {
        // error messages [ array { type: 'required', msg: 'This field is required.'}]
        // type correlates to form.inputName.$error keys.
        errorMessages: '<',
        // pass in a reference to the form form the parent for validation.
        form: '=',
        // label to use for the field
        label: '@',
        // model to bind
        model: '=',
        // element name
        name: '@',
        // whether the field should be required, this will not be tested, unless validate is true
        required: '<',
    }
};



// WEBPACK FOOTER //
// ./app/jangl/jangl-textarea/component.js